// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { TabletTab } from 'components/molecules/TabletTab';
import { PrimaryTemplate } from 'components/templates/PrimaryTemplate';
import ShipmentRegistration from 'components/organisms/ShipmentRegistration';
import ShipmentQR from 'components/organisms/ShipmentQR';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const Shipment = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const [tabIndex, setTabIndex] = useState<number>(
    history.location.hash === '#1' ? 1 : 0
  );

  return (
    <PrimaryTemplate h1={t('compressions.shipment.title')}>
      <TabletTab
        tabItems={[
          t('compressions.shipment.tabs.registration'),
          t('compressions.shipment.tabs.QR'),
        ]}
        setTabIndex={setTabIndex}
        defaultTabIndex={tabIndex}
        renderContent={({ index }) => {
          return (
            <div className="scroll-contents">
              {index === 0 && <ShipmentRegistration />}
              {index === 1 && <ShipmentQR />}
            </div>
          );
        }}
      />
    </PrimaryTemplate>
  );
};

export default Shipment;
